export default "__VITE_PUBLIC_ASSET__03a199cf__"